/**
 * Sort flatten result by date blocks
 *
 * Sort the flattened result by date blocks. Date headers look like
 * "20261020" or may have a prefix like "TBC_20261020". We
 * extract the trailing 8-digit YYYYMMDD and sort blocks by that.
 * apply sorting to the flatten result
 *
 * @param {Array} arr the flattened matches data array.
 * @returns {Array} array sorted by date
 */
export const sortFlattenResultByDateBlocks = (arr) => {
    const extractDate = (val) => {
        const regex = /(\d{8})$/;
        const m = regex.exec(String(val));
        return m ? m[1] : null;
    };

    const buildDateBlocks = (items) => {
        const blocks = [];
        let current = null;

        for (const item of items) {
            const date = extractDate(item);
            if (date) {
                if (current) {
                    blocks.push(current);
                }
                current = { dateValue: date, items: [item] };
            } else if (current) {
                current.items.push(item);
            } else {
                current = { dateValue: null, items: [item] };
            }
        }

        if (current) {
            blocks.push(current);
        }
        return blocks;
    };

    const blocks = buildDateBlocks(arr);
    if (!blocks.length) {
        return arr;
    }

    const dated = blocks
        .filter((b) => b.dateValue)
        .sort((a, b) => {
            let compareValue = 0;

            if (a.dateValue > b.dateValue) {
                compareValue = 1;
            } else if (a.dateValue < b.dateValue) {
                compareValue = -1;
            }

            return compareValue;
        });
    const undated = blocks.filter((b) => !b.dateValue);

    return [...dated, ...undated].flatMap((b) => b.items);
};
